<template>
  <div class="popover">
    <div class="popover-box" aria-describedby="tooltip">
      <div class="activator-box" ref="activator">
        <slot name="activator" :on="show"/>
      </div>
    </div>

    <div class="popover-content"
         role="tooltip"
         ref="popover"
         :style="computedWidth"
         :class="{'invisible': !popover, 'open': popover}">

      <div class="popover-header"
           v-if="!!this.$slots.header">
        <slot name="header"/>

        <v-btn class="popover-close"
               size="sm"
               @click="hide()">
          <v-icon icon="close"></v-icon>
        </v-btn>
      </div>

      <div class="popover-body"
           v-if="!!this.$slots.body">
        <slot name="body"/>
      </div>

      <div class="popover-footer pb-16"
           v-if="!!this.$slots.footer">
        <slot name="footer"/>
      </div>

      <div class="popover-arrow" data-popper-arrow></div>
    </div>
  </div>
</template>

<script>
import {createPopper} from '@popperjs/core';

export default {
  name: 'VPopover',
  emits: ['show', 'hide', 'toggle'],
  data() {
    return {
      popover: false,
    };
  },
  props: {
    width: {
      type: [Number, String],
      default: 'auto',
    },
    top: {
      type: Boolean,
      default: true,
    },
    right: Boolean,
    left: Boolean,
    bottom: Boolean,
    placement: String,
    active: Boolean,
    rootBoundary: {
      type: String,
      default: 'viewport',
    }
  },
  computed: {
    computedWidth() {
      return {
        width: !!this.width && this.width !== 'auto' ? `${this.width}px` : this.width,
      };
    },
    placementCalc() {
      let placement = this.placement;

      if (!this.placement && (this.top || this.right || this.left)) {
        placement = this.top ? 'top' : placement
        placement = this.right ? 'right' : placement
        placement = this.left ? 'left' : placement
        placement = this.bottom ? 'bottom' : placement
      }

      return placement;
    },
    offset() {
      let tmp = '';

      if (this.placement === 'top-end' || this.placement === 'bottom-end') {
        tmp = 22;
      } else if (this.placement === 'top-start' || this.placement === 'bottom-start') {
        tmp = -22;
      }

      return tmp;
    },
    hasActivator() {
      return Boolean(
        !!this.$slots.activator ||
        !!this.$scopedSlots.activator
      )
    },
  },
  methods: {
    createInstance() {
      const activator = this.$refs.activator;
      const popover = this.$refs.popover;

      if (!!activator && !!popover) {
        createPopper(activator.children[0], popover, {
          placement: this.placementCalc,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [this.offset ?? 0, 32],
              },
            },
          ],
        });
      }
    },
    show() {
      this.popover = true;

      this.$emit('show');
    },
    hide() {
      this.popover = false;

      this.$emit('hide');
    },
    toggle() {
      this.popover = !this.popover

      this.$emit('toggle');
    },
  },
  mounted() {
    this.createInstance();

    if (!this.hasActivator || this.active) {
      this.show();
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'VPopover';
</style>
